import "./App.scss";

import { BasicComponent, Overlay } from "haxt";
import { Header } from "./layout/Header";
import { Content } from "./layout/Content";
import { Footer } from "./layout/Footer";

export class App extends BasicComponent {

	public render() {
		return (
			<div class="App">
				<Header />
				<Content />
				<Footer />
			</div>
		);
	}
}

// check if search has ?debug=I_know_what_im_doing
const urlParams = new URLSearchParams(window.location.hash.substring(1));
if (urlParams.get('debug') === 'I_know_what_im_doing') {
	class Debug extends BasicComponent {
		public render() {
			return (
				<div class="Debug">
					<div>
						<input type="checkbox" onChange={(e) => {
							if ((e.target as HTMLInputElement).checked) {
								document.body.classList.add("debug-hero-overlay");
							} else {
								document.body.classList.remove("debug-hero-overlay");
							}
						}} />
						<label for="debug-show-borders">Video 30% Black Overlay</label>
					</div>
					<div>
						<input type="checkbox" onChange={(e) => {
							if ((e.target as HTMLInputElement).checked) {
								document.body.classList.remove("debug-no-logo-drop-shadow");
							} else {
								document.body.classList.add("debug-no-logo-drop-shadow");
							}
						}} checked />
						<label for="debug-show-borders">Logo drop shadow</label>
					</div>
				</div>
			);
		}
	}

	Overlay.addFloatingFragment(Debug, {});
}
